import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
	return (
		<Card className="quote-card-view">
			<Card.Body>
				<blockquote className="blockquote mb-0">
					<p style={{ textAlign: "justify" }}>
						Hi everyone,
						<br />
						<br />I am: <b className="purple">Jackson Phan </b>.
						<br />
						Age: <b className="purple">{new Date().getFullYear() - 2002}</b>
						<br />
						Gender: <b className="purple">Male</b>
						<br />
						<br />
						I graduated Bachelor of Information Technology, majors in Computer
						Science and Data Science in December 2023 from Queensland University
						of Technology, Brisbane with High Distinction.
						<br />
						<br />I am fluent in
						<i>
							<b className="purple">
								{" "}
								C#, Java, JavaScript, Python, HTML, CSS.{" "}
							</b>
						</i>
						<br />
						<br />
						My experiences:
					</p>
					<ul>
						<li className="about-activity">
							<ImPointRight /> Software Engineer at{" "}
							<b className="purple">Jung Talents</b>
							<br />
							<i>
								Partnered with cross-functional teams in an Agile environment to design and deliver scalable solutions for various web applications and microservices. Leveraged the JavaScript ecosystem by building full-stack solutions using React and Next.js on the front end, and Node.js frameworks such as Express and Nest.js on the back end. Developed optimised parallel database query mechanisms for PTE Master, reducing search query times by 40% and significantly enhancing user experience. Collaborated with Business Analysts and QA Engineers to ensure all deliverables met client specifications and quality standards. Deployed cloud-native applications on AWS, utilising Docker for containerisation to boost scalability and performance. Led code review sessions, providing constructive feedback to support team growth and uphold high code quality.
							</i>
						</li>
						<br />
						<li className="about-activity">
							<ImPointRight /> Software Engineer at{" "}
							<b className="purple">Volvo Group Australia</b>
							<br />
							<i>
								Conducted in-depth analysis of legacy systems to identify unnecessary local customisations, recommending standardised solutions to reduce complexity and technical debt. Played a key role in the organisation’s digital transformation by modernising and redeveloping legacy applications using C#, ASP.NET Razor Pages, .NET Core, and WinForms, significantly improving performance and maintainability. Assisted in developing enterprise web and desktop applications using UWP and Microsoft Power Platform (Power Apps and Power Automate) to enable business process automation and system integration. Utilised Azure DevOps, Jira, and Confluence for task tracking, version control, and collaborative documentation, maintaining consistent Agile delivery practices. Successfully contributed to the redevelopment of a critical legacy system, achieving a 30% reduction in maintenance efforts and ensuring seamless integration with modern platforms.
							</i>
						</li>
						<br />
						<li className="about-activity">
							<ImPointRight /> Software Engineer at{" "}
							<b className="purple">ARQ Group (NCS Next)</b>
							<br />
							<i>
								Designed and developed a predictive analytics algorithm that combined tide and weather data to enhance flood warning forecasts for Brisbane City Council, achieving 93% model accuracy. Built and maintained robust data pipelines in Databricks to process large datasets, including no-wind tide estimates, historical tides, weather data, and forecasts. Applied advanced data analysis and machine learning techniques to model wind impact on tidal behaviour by comparing no-wind predictions with actual tide levels. Developed a web-based interface using React.js and Node.js to deliver prediction results in a user-friendly format. Followed Agile methodologies with Jira for task tracking, sprint reviews, and stand-ups, while leveraging AWS cloud services for scalable deployment and efficient data integration.
							</i>
						</li>
						<br />
						<li className="about-activity">
							<ImPointRight /> Software Engineer at{" "}
							<b className="purple">Planté</b>
							<br />
							<i>
								Collaborated within a four-member team to design and develop a professional website that effectively showcased the company’s brand, services, and environmental mission. Automated and optimised data processing workflows for tree and plant information, improving accuracy, efficiency, and scalability. Contributed to the development of the company’s mobile application, implementing features, conducting testing, and enhancing UI/UX for consistent cross-platform performance. Strengthened software security by applying secure coding practices, authentication protocols, and vulnerability mitigation measures, achieving a 40% improvement in system security. The completed platform enhanced internal operations and customer engagement, ultimately helping the company secure new partnerships in the environmental sector.
							</i>
						</li>
					</ul>
				</blockquote>
			</Card.Body>
		</Card>
	);
}

export default AboutCard;
